import React from 'react';
import {useTranslation} from 'react-i18next';
import {Button} from "react-bootstrap";
import {connect, useDispatch} from "react-redux";
import {SET_SUBSCRIPTION_EMAIL, SUBSCRIBE} from "../../actions/subscribe";

const Subscribe = (props) => {
    const {
        subscriptionEmail, status
    } = props;

    const {t} = useTranslation();
    const dispatch = useDispatch();

    const handleEmailChange = (event) => {
        dispatch({
            type: SET_SUBSCRIPTION_EMAIL,
            payload: event.target.value
        })
    };

    const handleEmailSubscription = (event) => {
        dispatch({
            type: SUBSCRIBE,
        })
    };

    return (
        <div className="footer-subscribe">
            <h2>{t('subscribe.title')}</h2>
            <p>{t('subscribe.subtitle')}</p>
            <form onSubmit={event => {event.preventDefault(); handleEmailSubscription(event);}}>
                <input name="subscriptionEmail" type="email" required aria-label={t('subscribe.email.label')} placeholder={t('subscribe.email.placeholder')} value={subscriptionEmail} disabled={status === 'loading'} onChange={handleEmailChange}/>
                <Button id="subscribeButton" variant="primary" type="submit" disabled={status === 'loading'}>{t('subscribe.email.button')}</Button>
            </form>
            {status === 'success' && <p role="status">{t('subscribe.thanks')}</p>}
            {status === 'error' && <p role="alert">{t('subscribe.error')}</p>}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        subscriptionEmail: state.subscribe.subscriptionEmail,
        status: state.subscribe.status,
    };
};

export default connect(mapStateToProps)(Subscribe);